import { EMPTY_FUNCTION, EMPTY_OBJECT } from './common'

export const DEFAULT_DRAFT_CONTEXT_VALUE = {
  draft: null,
  draftId: null,
  getLatestDraft: EMPTY_FUNCTION,
  setDraft: (draft, timeout = 0) => void [draft, timeout],
}

export const SAVE_DRAFT_TIMEOUT = 3000

export const DEFAULT_DRAFTS = EMPTY_OBJECT
